import React from 'react';
import { MOCK_UP_IMAGE_LAYER } from '../../../../propTypes';
import { DEFAULT_MIX_BLEND_MODE, DEFAULT_OPACITY, DEFAULT_Z_INDEX } from '../../constants';

export const ImageLayer = ({
    src,
    zIndex = DEFAULT_Z_INDEX,
    mixBlendMode = DEFAULT_MIX_BLEND_MODE,
    opacity = DEFAULT_OPACITY,
    transformOrigin,
    transform,
    visible = false
}) => (
    visible && <img src={src} alt="" style={{ zIndex, mixBlendMode, opacity, transform, transformOrigin }} className="image-layer layer"/>
);

ImageLayer.propTypes = MOCK_UP_IMAGE_LAYER;
